import {IOrganisation} from "../../common/organisation";

export type InitialState = Record<IOrganisation['alias'], IOrganisation>

export const enum ACTION_TYPES {
    GET_MY_ORGANISATION_SUCCESS = 'getMyOrganisationSuccess',
    GET_MY_ORGANISATION = 'getMyOrganisation',
    GET_ORGANISATION_PROFILES = 'getOrganisationProfiles',
    GET_MY_ORGANISATION_PROFILES_SUCCESS = 'getOrganisationProfilesSuccess',
    ADD_PROFILE = 'addProfile',
    DELETE_PROFILE = 'deleteProfile',
    CHANGE_ORGANISATION_SETTINGS = 'changeOrganisationSettings',
    UPDATE_PROFILE = 'updateProfile',
    UPDATE_PROFILES = 'updateProfiles',
};

export type Actions = {
    type: ACTION_TYPES,
    payload: any,
};